export interface IExplorationPointSetting {
  // 탐색포인트 시스템 활성화 여부
  isActive: boolean;

  // 탐색포인트 획득 시간 (분 단위)
  acquisitionInterval: number;

  // 시간마다 획득할 탐색포인트
  pointsPerInterval: number;

  // 최대 탐색포인트
  maxPoints: number;

  // 탐색 포인트 아이콘 URL (선택)
  pointIconURL?: string;

  // 탐색 보드 카드 타입: 기본 | 이미지
  boardCardType?: 'default' | 'image';

  // 탐색 카드 앞/뒷면 이미지 URL
  cardFrontImageURL?: string;
  cardBackImageURL?: string;

  // 조사 지문용 아이템 설정
  investigationItemName?: string; // 아이템 이름
  investigationItemImageURL?: string; // 아이템 이미지
  investigationItemDescription?: string; // 아이템 설명
  investigationItemFunctionType?: string; // 아이템 기능 타입 (ITEM_FUNCTION_TPYE.INVESTIGATION)

  // 타임라인 조사하기에서 탐색 포인트 사용 여부
  useExplorationPointForInvestigation?: boolean;

  // 조사하기에 필요한 탐색 포인트
  investigationPointCost?: number;
}

// 기본값 설정
export const initialExplorationPointSetting: IExplorationPointSetting = {
  isActive: false,
  acquisitionInterval: 60, // 60분마다
  pointsPerInterval: 1, // 1포인트 획득
  maxPoints: 5, // 최대 5포인트
};
